export const SET_EXAMPLE_STATE = "SET_EXAMPLE_STATE";
export const SET_USER = "SET_USER";
export const GET_USER = "GET_USER";
export const GET_ACCOUNT = "GET_ACCOUNT";
export const SET_LOGIN_ERROR = "SET_LOGIN_ERROR";
export const SET_REGISTRATION_ERROR = "SET_REGISTRATION_ERROR";
export const STORE_PENDING_ORDERS_DATA = "STORE_PENDING_ORDERS_DATA";
export const CUSTOMER_FILTER = "CUSTOMER_FILTER";
export const COMPANY_FILTER = "COMPANY_FILTER";
export const STATUS_FILTER = "STATUS_FILTER";
export const DATE_FILTER = "DATE_FILTER";
export const STORE_CUSTOMER_DETAILS = "STORE_CUSTOMER_DETAILS";
export const STORE_PLANS = "STORE_PLANS";
export const STORE_LOADER = "STORE_LOADER";
export const UPDATE_USER = "UPDATE_USER";
export const ORDERS_MANIPULATED = "ORDERS_MANIPULATED";
export const ONBOARDING_VERIFIED = "ONBOARDING_VERIFIED";
export const STORE_ACCOUNT_DETAILS = "STORE_ACCOUNT_DETAILS";
export const SET_ACCOUNT_COMPANY = "SET_ACCOUNT_COMPANY";
export const SET_ACCOUNT_ADDRESS = "SET_ACCOUNT_ADDRESS";
export const SET_ACCOUNT_INSTRUCTIONS = "SET_ACCOUNT_INSTRUCTIONS";
export const SET_ACCOUNT_EMAIL_SIGNATURE = "SET_ACCOUNT_EMAIL_SIGNATURE";
export const ENABLE_SEND_INVOICE_ON_PENDING_ORDER_CREATION_SETTING =
  "ENABLE_SEND_INVOICE_ON_PENDING_ORDER_CREATION_SETTING";
export const DISABLE_SEND_INVOICE_ON_PENDING_ORDER_CREATION_SETTING =
  "DISABLE_SEND_INVOICE_ON_PENDING_ORDER_CREATION_SETTING";
export const SET_ACCOUNT_INVOICE_TEMPLATE = "SET_ACCOUNT_INVOICE_TEMPLATE";
export const SET_LOGO = "SET_LOGO";
// Calculate net payment days from fulfillment date setting
export const CALCULATE_NET_PAYMENT_DAYS_FROM_FULFILLMENT_DATE_SETTING =
  "CALCULATE_NET_PAYMENT_DAYS_FROM_FULFILLMENT_DATE_SETTING";
// Remove calculate net payment days from fulfillment date setting
export const REMOVE_CALCULATE_NET_PAYMENT_DAYS_FROM_FULFILLMENT_DATE_SETTING =
  "REMOVE_CALCULATE_NET_PAYMENT_DAYS_FROM_FULFILLMENT_DATE_SETTING";
export const USER_NOTIFIED_FOR_EXHAUSTED_LIMIT = "USER_NOTIFIED_FOR_EXHAUSTED_LIMIT";
export const DECREMENT_ORDER_LIMIT = "DECREMENT_ORDER_LIMIT";
export const SET_NEW_SCOPE_ACCEPTED = "SET_NEW_SCOPE_ACCEPTED";
export const ADD_CUSTOM_NET_TERMS_MUTATION = "ADD_CUSTOM_NET_TERMS_MUTATION";
export const REMOVE_CUSTOM_NET_TERMS_MUTATION = "REMOVE_CUSTOM_NET_TERMS_MUTATION";
// Add/Remove custom net term
export const ADD_CUSTOM_NET_TERM = "ADD_CUSTOM_NET_TERM";
export const REMOVE_CUSTOM_NET_TERM = "REMOVE_CUSTOM_NET_TERM";
// Multiple email address
export const ADD_EMAIL_MULTIPLE_EMAIL_ADDRESS = "ADD_EMAIL_MULTIPLE_EMAIL_ADDRESS";
export const REMOVE_EMAIL_MULTIPLE_EMAIL_ADDRESS = "REMOVE_EMAIL_MULTIPLE_EMAIL_ADDRESS";
export const ENABLE_DISABLE_EMAIL_MULTIPLE_EMAIL_ADDRESS = "ENABLE_DISABLE_EMAIL_MULTIPLE_EMAIL_ADDRESS";
export const UPDATE_STATEMENT_DAYS = "UPDATE_STATEMENT_DAYS";
export const STATEMENT_FOR_CUSTOMERS = "STATEMENT_FOR_CUSTOMERS";
export const REMOVE_STATEMENT_FOR_CUSTOMERS = "REMOVE_STATEMENT_FOR_CUSTOMERS";
export const RESET_ACCOUNT_FRONTEND = "RESET_ACCOUNT_FRONTEND";
// Periodic Updates
export const ADD_PERIODIC_UPDATES = "ADD_PERIODIC_UPDATES";
export const REMOVE_PERIODIC_UPDATES = "REMOVE_PERIODIC_UPDATES";

//Send stripe link into email
export const ENABLE_SEND_STRIPE_PAYMENT_LINK_IN_EMAIL = "ENABLE_SEND_STRIPE_PAYMENT_LINK_IN_EMAIL";
export const DISABLE_SEND_STRIPE_PAYMENT_LINK_IN_EMAIL = "DISABLE_SEND_STRIPE_PAYMENT_LINK_IN_EMAIL";

//Send shopify checkout link into email
export const ENABLE_SEND_SHOPIFY_CHECKOUT_PAYMENT_LINK_IN_EMAIL = "ENABLE_SEND_SHOPIFY_CHECKOUT_PAYMENT_LINK_IN_EMAIL";
export const DISABLE_SEND_SHOPIFY_CHECKOUT_PAYMENT_LINK_IN_EMAIL =
  "DISABLE_SEND_SHOPIFY_CHECKOUT_PAYMENT_LINK_IN_EMAIL";
